import { getCachedConfig } from '../../config';
import { getNavEl } from '../../utils/getNavEl';
import { getPortalId } from '../../utils/getPortalId';
import setNavPlaceholderType from '../../utils/setNavPlaceholderType';
import { renderFallbackNav } from './renderFallbackNav';
import { renderRootNav } from './renderRootNav';
export function renderNav(callback) {
  const portalId = getPortalId();
  if (!portalId) {
    console.warn('No portal id found. This version of the navigation requires a portal id. ' + 'Avoid using the regular navigation on hubless pages.');
    return;
  }
  const renderNavWithConfigResponse = resp => {
    if (!getNavEl()) {
      setTimeout(() => {
        renderNavWithConfigResponse(resp);
      }, 10);
      return;
    }
    renderRootNav(callback, resp);
  };
  const configCallback = resp => {
    if (!resp) {
      renderFallbackNav();
      return;
    }
    setNavPlaceholderType();
    renderNavWithConfigResponse(resp);
    return;
  };
  return getCachedConfig(configCallback);
}